import React from 'react';

// import sections
import Hero from '../components/sections/Hero';
import Section2 from '../components/sections/Section2';

import Section3 from '../components/sections/Section3';
import Section4 from '../components/sections/Section4';
import Section7 from '../components/sections/Section7';
import Pricing from '../components/sections/Pricing';
import Section6 from '../components/sections/Section6';
import TimeLine from '../components/sections/TimeLine';
// import ScrollTop from '../components/elements/ScrollTop';

import section2Content from '../contents/section2Content.json';
import timelineContent from '../contents/timelineContent.json';

const Home = () => {

  return (
    <div>
      <Hero id='hero' className="illustration-section-01" />
      <Section2 id="section2" topDivider content={section2Content}/>
      <Pricing  id="pricing"  />
      <Section3 id="features" />
      <Section4 id="section4" invertMobile topDivider imageFill className="illustration-section-02" />
      <Section6 id="map" topDivider />
      <TimeLine id="timeLine" content={timelineContent}/>
      <Section7 split />
    </div>
  );
}

export default Home;
